<template>
  <v-dialog v-model="value" width="700px" persistent>
    <v-card>
      <div class="container_flex">
        <v-card-title primary-title class="justify-center item_title">
          <span class="dialog-card__titulo">Política de Privacidade</span>
        </v-card-title>
      </div>

      <v-card-text class="dialog-card__text">
        <v-card-text>
          <div class="grey lighten-3 dialog-card__border">
            <v-container>
              <p class="dialog-card__text">
                {{ text }}
              </p>
            </v-container>
          </div>
        </v-card-text></v-card-text
      >

      <v-divider></v-divider>

      <v-card-actions>
        <div class="mb-2">
          <a :href="link" target="_blank" class="link ml-3 "
            >Política de Privacidade</a
          >
        </div>

        <v-spacer></v-spacer>
        <v-btn
          class="mr-2 mb-2"
          color="green accent-4 text-blue white--text"
          text
          @click="(value = false), $emit('accepted')"
        >
          Aceitar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'warning',
  emits: ['accepted'],
  data: () => ({
    value: true
  }),
  props: {
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-card__border {
  border-radius: 5px;
}

.dialog-card__text {
  color: #666666;
  font-size: 14px;
  font-family: 'Open Sans';
}

.dialog-card__titulo {
  color: #666666;
  font-size: 20px;
  font-family: 'Open Sans';
}

.container_flex {
  display: flex;
}

.item_title {
  flex: 2;
  padding-bottom: 0px;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/lgpd/Warning.vue